export * from './delete-zeit-unterart-request.interface';
export * from './delete-zeit-unterart-response.interface';
export * from './delete-zeit-unterart.shapes';
